import { render, staticRenderFns } from "./reCheckCharmSummaryTab.vue?vue&type=template&id=1c530f86"
import script from "./reCheckCharmSummaryTab.vue?vue&type=script&lang=js"
export * from "./reCheckCharmSummaryTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c530f86')) {
      api.createRecord('1c530f86', component.options)
    } else {
      api.reload('1c530f86', component.options)
    }
    module.hot.accept("./reCheckCharmSummaryTab.vue?vue&type=template&id=1c530f86", function () {
      api.rerender('1c530f86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/reCheckCharmSummaryTab.vue"
export default component.exports